import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "lg:hidden border-b-2 border-gray-stroke pb-4 pt-2 mx-8 mb-4 font-bold text-lg" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "absolute top-4 right-8 lg:static lg:flex lg:items-center lg:justify-center" }

import { TableMain, TableTh, TableTd, TableTr, TableTHead, TableTBody } from './partials'
import { ITableData, ERowTypes, TableBody, CustomCell } from '@/types/interfaces/table'


export default /*#__PURE__*/_defineComponent({
  props: {
    collection: { type: null, required: false },
    data: { type: null, required: true },
    horizontalOnMobile: { type: Boolean, required: false },
    cellClassOnMobile: { type: String, required: false }
  },
  setup(__props: any) {

const props = __props as {
    collection?: unknown
    data: ITableData
    horizontalOnMobile?: boolean
    cellClassOnMobile?: string
}
/* eslint-disable vue/no-v-html */


const isComponentCell = (f: TableBody): f is CustomCell => {
    return f !== null && typeof f === 'object' && (f as CustomCell).component !== undefined
}
const isHtmlCell = (f: TableBody): f is CustomCell => {
    return f !== null && typeof f === 'object' && (f as CustomCell).html !== undefined
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TableMain), null, {
    default: _withCtx(() => [
      _createVNode(_unref(TableTHead), null, {
        default: _withCtx(() => [
          _createVNode(_unref(TableTr), null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data.head, (item, idx) => {
                return (_openBlock(), _createBlock(_unref(TableTh), {
                  key: item,
                  class: _normalizeClass(["py-4 px-3 text-left", { 'text-center': idx === props.data.head.length - 1 }])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item), 1)
                  ]),
                  _: 2
                }, 1032, ["class"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(TableTBody), null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data.body, (row, rowId) => {
            return (_openBlock(), _createBlock(_unref(TableTr), {
              id: parseInt(rowId.toString()),
              key: `row-${rowId.toString()}`,
              class: "relative px-3",
              "custom-class": props.cellClassOnMobile
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _renderSlot(_ctx.$slots, "row-title", {
                    row: row,
                    index: rowId
                  }, () => [
                    (isHtmlCell(row[0]))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          innerHTML: row[0].html
                        }, null, 8, _hoisted_2))
                      : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(row[0]), 1))
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, cellId) => {
                  return (_openBlock(), _createBlock(_unref(TableTd), {
                    key: `cell-${cellId.toString()}`,
                    "custom-class": 
                        typeof cell === 'object' && cell?.type === _unref(ERowTypes).HIDDEN
                            ? 'hidden p-0 m-0 border-2'
                            : ''
                    
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass([
                            props.horizontalOnMobile
                                ? 'grid grid-rows-2 lg:grid-rows-1'
                                : 'grid grid-cols-2 lg:grid-cols-1',
                        ])
                      }, [
                        _createElementVNode("strong", {
                          class: _normalizeClass(["lg:hidden", {
                                'uppercase text-primary text-xs block mb-2':
                                    props.horizontalOnMobile,
                            }])
                        }, _toDisplayString(props.data.head[parseInt(cellId.toString())]), 3),
                        (isComponentCell(cell) && cell?.type === _unref(ERowTypes).COMPONENT)
                          ? (_openBlock(), _createBlock(_resolveDynamicComponent(cell?.component), _normalizeProps(_mergeProps({ key: 0 }, cell?.componentConfig)), null, 16))
                          : (isHtmlCell(cell))
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                innerHTML: cell?.html
                              }, null, 8, _hoisted_4))
                            : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(cell), 1))
                      ], 2)
                    ]),
                    _: 2
                  }, 1032, ["custom-class"]))
                }), 128)),
                (_ctx.$slots['row-actions'])
                  ? (_openBlock(), _createBlock(_unref(TableTd), { key: 0 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _renderSlot(_ctx.$slots, "row-actions", {
                            row: row,
                            item: props.collection ? (props.collection as Record<string, unknown>)[rowId] : {}
                          })
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["id", "custom-class"]))
          }), 128))
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})